import { Component, Inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationStart, Router } from '@angular/router';

@Component({
	selector: 'app-quotation-mobile-modal',
	templateUrl: './quotation-mobile-modal.component.html',
	styleUrl: './quotation-mobile-modal.component.scss',
})
export class QuotationMobileModalComponent<T> implements OnInit, OnDestroy {
	static readonly ID = crypto.randomUUID();

	private routerSubscription: Subscription;

	constructor(
		@Inject(MAT_DIALOG_DATA) public contentTemplate: TemplateRef<T>,
		private readonly matDialogRef: MatDialogRef<QuotationMobileModalComponent<T>>,
		private readonly modalService: ModalService,
		private readonly router: Router,
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.matDialogRef);
		this.routerSubscription = this.router.events
			.pipe(filter((event) => event instanceof NavigationStart))
			.subscribe(this.matDialogRef.close.bind(this.matDialogRef));
	}

	ngOnDestroy() {
		this.routerSubscription?.unsubscribe();
	}

	onClose(): void {
		this.matDialogRef.close();
	}
}
